import React from "react";
import { Box, Flex, Text, Button, TouchableOpacity } from "@atoms";
import { ImageCircle, NoAvatar } from "@molecules";
import { constants } from "@services";
import { useStoreAppValue, useToggle } from "@hooks";
import { ReassignMember, RemoveMember } from "../Modals";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps {
  isGroups: boolean;
  fundraiser: {
    id: string;
    name: string;
    firstName: string;
    lastName: string;
    userId: string;
    avatarImage: string;
    isOwner: boolean;
    isViewerOwner: boolean;
    joinedAt: string;
    deactivatedAt: string;
    group: $FixMe;
  };
  groupedFundraisers: $FixMe;
  isViewerOwner: boolean;
  refetch: () => void;
  activeReassignmentMemberId: string | null;
  setActiveReassignmentMemberId: (value: string | null) => void;
}

// == Constants ============================================================

MemberListItem.defaultProps = {};

// == Component ============================================================

export default function MemberListItem({
  isViewerOwner,
  fundraiser,
  groupedFundraisers,
  isGroups,
  refetch,
  activeReassignmentMemberId,
  setActiveReassignmentMemberId,
}: IProps) {
  const {
    id,
    name,
    firstName,
    lastName,
    userId,
    avatarImage,
    isOwner,
    joinedAt,
    deactivatedAt,
    group,
  } = fundraiser;

  const [isRemoveMemberOpen, setIsRemoveMemberOpen] = useToggle(false);
  const currentUserId = useStoreAppValue()?.currentUser?.id.toString();
  const isPending = !isOwner && !joinedAt && !deactivatedAt && !group;
  const isAvatarImage = !avatarImage?.includes(constants.DEFAULT_USER_AVATAR_STRING);
  const isViewerFundraiser = fundraiser.userId === currentUserId;
  const isReassignable = isGroups && !isPending;
  const isRemovable =
    (!isViewerOwner && isViewerFundraiser) || (isViewerOwner && !isViewerFundraiser);

  if (deactivatedAt) return null;

  return (
    <>
      <Flex alignItems="center" justifyContent="space-between" padding={[1, 2, 3]}>
        <TouchableOpacity
          containerProps={{ style: { cursor: isReassignable ? "pointer" : "default" } }}
          onTouch={() => (isReassignable ? setActiveReassignmentMemberId(id) : null)}
        >
          <Flex alignItems="center" justifyContent="flex-start">
            <Box>
              {!!avatarImage && !!isAvatarImage ? (
                <ImageCircle
                  alt={name}
                  bg="lightBlueBg"
                  faded={!!deactivatedAt}
                  height={50}
                  src={avatarImage}
                  width={50}
                />
              ) : (
                <NoAvatar firstName={firstName || name} lastName={lastName} />
              )}
            </Box>
            <Flex alignItems="flex-start" flexDirection="column" paddingLeft={3}>
              <Text display="block" fontSize={[1, 2]}>
                {name === id ? `${name} (Team)` : name}
              </Text>
              {!!isOwner && (
                <Text color="primary" display="block" fontSize={[0, 1]}>
                  Captain
                </Text>
              )}
            </Flex>
          </Flex>
        </TouchableOpacity>
        <Box>
          {isRemovable && (
            <Button variant="clear" onClick={() => setIsRemoveMemberOpen(true)}>
              Remove
            </Button>
          )}
        </Box>
      </Flex>
      {activeReassignmentMemberId === id && !!isGroups && (
        <ReassignMember
          activeReassignmentMemberId={activeReassignmentMemberId}
          currentGroup={group}
          groupedFundraisers={groupedFundraisers}
          id={id}
          name={name}
          refetch={refetch}
          setActiveReassignmentMemberId={setActiveReassignmentMemberId}
          userId={userId}
        />
      )}
      {!!isRemoveMemberOpen && (
        <RemoveMember
          id={id}
          isRemoveMemberOpen={isRemoveMemberOpen}
          name={name}
          setIsRemoveMemberOpen={setIsRemoveMemberOpen}
          userId={userId}
        />
      )}
    </>
  );
}

// == Styles ===============================================================
